import { cloneDeep, isEqual } from 'lodash';

var clone = obj => cloneDeep(obj);

var compareDeep = (a, b) => isEqual(a, b);

var mergeArrays = arrays => arrays.reduce((mergedResults, singleResult) => [...mergedResults, ...singleResult], []);

var sortByCount = array => array.sort((a, b) => b.count - a.count);

var sortBySortAttribute = array => array.sort((a, b) => b[b.sort] - a[a.sort]);

var groupByProperty = (array, property) =>
	array.reduce((grouped, element) => {
		if (element[property] in grouped) {
			grouped[element[property]].push(element);
		} else {
			grouped[element[property]] = [element];
		}
		return grouped;
	}, {});

var groupByKey = array => groupByProperty(array, 'key');
var groupByName = array => groupByProperty(array, 'name');

var createUniqueKeys = array => {
	const duplicates = array.reduce((dup, element) => {
		dup[element.key] = !dup[element.key] ? 1 : dup[element.key] + 1;
		return dup;
	}, {});

	return array.map(element => {
		if (!(element.key in duplicates)) {
			return element;
		} else if (duplicates[element.key] === 1) {
			element.uniqueKey = element.key;
			return element;
		} else {
			duplicates[element.key] = duplicates[element.key] - 1;
			element.uniqueKey = element.key + duplicates[element.key];
			return element;
		}
	});
};

var filterUndefined = state => state !== null && typeof state !== 'undefined';

var onlyLoadingAndLoadedResponses = state => state.status === 'loaded' || state.status === 'loading';

var onlyLoadedResponses = state => state.status === 'loaded';

var onlyLoadingResponses = state => state.status === 'loading';

var onlyIdleResponses = state => state.status === 'idle';

var onlyDataPrefetching = (data, mode) => (mode.datafetching ? data : null);

var getResponseProperty = obj => (obj ? obj.response : null);

var getDocumentsProperty = obj => (obj ? obj.documents : null);

var getFirstArrayEntry = array => (array && array.length > 0 ? array[0] : null);

var checkRenderedFinished = lastTwoValues => {
	if (lastTwoValues[0].rendering && lastTwoValues[1].rendered) return true;
	else if (lastTwoValues[0].prepareRendering && lastTwoValues[1].rendered) return true;
	else return null;
};

var checkRenderingStarted = lastTwoValues => {
	if (!lastTwoValues[0].rendering && lastTwoValues[1].rendering) return true;
	else return null;
};

var checkDataFetchingStarted = lastTwoValues => {
	if (!lastTwoValues[0].datafetching && lastTwoValues[1].datafetching) return true;
	else return null;
};

var checkForEquality = (a, b) => {
	if (compareDeep(a, b)) return a;
	else return null;
};

const formatName = str => {
	if (!str || !str.split) return '';

	const SEPARATOR = ':';
	const parts = str.split(SEPARATOR);
	const type = parts.shift();

	if (type) {
		const name = parts.join(SEPARATOR);
		const knownPrefixes = ['dailymotion', 'facebook', 'googleplus', 'http', 'reddit', 'twitter', 'vimeo', 'youtube'];

		if (name === 'unknown') {
			return type;
		} else if (knownPrefixes.indexOf(type) > -1) {
			return name;
		}
	}

	return str;
};

var compareByArrayLength = (a, b) => a.length === b.length;

//used in keywordgraph, clustermap so far
var getRenderingStateProperty = prop => {
	var stateprop = {
		idle: false,
		datafetching: false,
		prepareRendering: false,
		rendering: false,
		rendered: false
	};

	stateprop[prop] = true;
	return stateprop;
};

var addCountPropertyToObject = (obj, count) => {
	var cloned = clone(obj);
	cloned.count = count;
	return cloned;
};

var addCountPropertyToArrayOfObjects = (objArray, count) => {
	var cloned = clone(objArray);
	var offset = cloned.length;
	var countPerObject = Math.ceil(count / cloned.length) + offset;
	cloned.map(x => (x.count = countPerObject));
	return cloned;
};

export {
	addCountPropertyToArrayOfObjects,
	addCountPropertyToObject,
	checkDataFetchingStarted,
	checkForEquality,
	checkRenderedFinished,
	checkRenderingStarted,
	clone,
	compareByArrayLength,
	compareDeep,
	createUniqueKeys,
	filterUndefined,
	formatName,
	getDocumentsProperty,
	getFirstArrayEntry,
	getRenderingStateProperty,
	getResponseProperty,
	groupByKey,
	groupByName,
	groupByProperty,
	mergeArrays,
	onlyDataPrefetching,
	onlyIdleResponses,
	onlyLoadedResponses,
	onlyLoadingAndLoadedResponses,
	onlyLoadingResponses,
	sortByCount,
	sortBySortAttribute
};
